import classNames from "classnames"
import React from "react"

const POSITION_MAPPER = {
  up: "rotate-180",
  down: "rotate-0"
}

type AnimatedArrowType = {
  "aria-hidden": boolean
  position?: keyof typeof POSITION_MAPPER
}

const AnimatedArrow = (props: AnimatedArrowType) => {
  const { position = "down", ...others } = props

  return (
    <svg
      className={classNames(
        "ml-1 h-4 w-4 transition ease-in-out delay-250 relative top-0.5",
        POSITION_MAPPER[position]
      )}
      viewBox="0 0 16 16"
      {...others}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 11.0008L3 6.00078L3.7 5.30078L8 9.60078L12.3 5.30078L13 6.00078L8 11.0008Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default AnimatedArrow
